import { decode } from 'jsonwebtoken';

const isJWTExpired = jwt => {
  const jwtData = decode(jwt);
  if (!jwtData) return true;
  let { exp: expires } = jwtData;
  expires *= 1000; // Convert from seconds to milliseconds
  expires -= 60 * 1000; // Consider it expired if within 1 minute of expiring
  const now = Math.round(new Date().getTime());

  return expires < now;
};

export default isJWTExpired;
